import { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MoreIcon from '@mui/icons-material/MoreVert';
import { GridColDef, GridRowParams, GridRowsProp } from '@mui/x-data-grid';

import SS from '../shared/styles';

interface IProps {
  page: number;
  pageSize: number;
  rows: GridRowsProp;
  totalElements: number;
  loading: boolean;
  fetchExternalUsers(): void;
  onPageChange(page: number): void;
  onPageSizeChange(pageSize: number): void;
  onRowClick(params: GridRowParams): void;
  onDeleteClick(id: string, name: string, callback: () => void): void;
}

const initialDialogData = {
  id: '',
  name: '',
};

function ExternalUsersTable(props: IProps) {
  const {
    page,
    pageSize,
    rows,
    totalElements,
    loading,
    fetchExternalUsers,
    onDeleteClick,
    onPageChange,
    onPageSizeChange,
    onRowClick,
  } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [dialogData, setDialogData] = useState(initialDialogData);

  const columns: GridColDef[] = [
    { field: 'name', headerName: 'Full Name', flex: 1, sortable: false },
    { field: 'email', headerName: 'Email', flex: 1, sortable: false },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <IconButton
          size="small"
          onClick={(event) =>
            handleOptionsClick(event, params.row._id as string, params.row.name as string)
          }
        >
          <MoreIcon fontSize="small" />
        </IconButton>
      ),
    },
  ];

  function handleMenuClose() {
    setAnchorEl(null);
    setDialogData(initialDialogData);
  }

  function handleOptionsClick(event: React.MouseEvent<HTMLElement>, id: string, name: string) {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setDialogData({ id, name });
  }

  function handleDeleteExternalUser() {
    if (dialogData.id) {
      onDeleteClick(dialogData.id, dialogData.name, () => {
        handleMenuClose();
        fetchExternalUsers();
      });
    }
    handleMenuClose();
  }

  return (
    <>
      <SS.DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row._id}
        disableColumnFilter
        disableColumnMenu
        disableSelectionOnClick
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        rowCount={totalElements}
        page={page}
        pageSize={pageSize}
        paginationMode="server"
        loading={loading}
        pagination
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        onRowClick={onRowClick}
      />
      <Menu
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => handleDeleteExternalUser()}>Delete</MenuItem>
      </Menu>
    </>
  );
}

export default ExternalUsersTable;
